<template>
  <div class="lives-video-orderlist">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入视频名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.pay_name"
                  clearable
                  filterable
                  placeholder="收单机构">
            <Option v-for="item in payNameList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportOrder()">导出订单</Button>
        </FormItem>

      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer title="审核"
            v-model="showModalStatus"
            width="800"
            scrollable
            :mask-closable="false"
            @on-ok="createuser('userValidate')"
            :loading="loading">
      <List>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">用户名:</span>
                {{dataInfo.user_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">订单号:</span>
                {{dataInfo.order_num }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">视频:</span>
                {{dataInfo.video_title }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">价格:</span>
                {{dataInfo.price }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">总价:</span>
                {{dataInfo.total_prices }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">用户备注:</span>
                {{dataInfo.mark }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">支付状态:</span>
                {{dataInfo.pay_status_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">支付时间:</span>
                {{dataInfo.pay_at }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">融宝支付返回code:</span>
                {{dataInfo.wxreturn_code }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">融宝返回信息:</span>
                {{dataInfo.wxreturn_msg }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">融宝回调返回信息:</span>
                {{dataInfo.wxreturn_msg2 }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">订单状态:</span>
                {{dataInfo.status_name }}
              </label>
            </li>
          </template>
        </ListItem>
      </List>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: "lives-video-orderlist",
  data () {
    return {
      loading: true,
      dataloading: true,
      showModalStatus: false,
      thumblist: [],
      title: "",
      payNameList: [
        { id: 0, name: "融宝" },
        { id: 1, name: "财付通" },],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "支付单号",
          key: "order_num",
          minWidth: 200
        },
        {
          title: "匠人",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.tradesman != null ? params.row.tradesman.nickname : ""
              )
            ]);
          }
        },
        {
          title: "视频",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.video != null ? params.row.video.title : ""
              )
            ]);
          }
        },
        {
          title: "用户名",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h("div", [h("span", {}, params.row.userdata != null ? params.row.userdata.username : '')]);
          }
        },
        {
          title: "总价",
          key: "total_prices",
          width: 200
        },
        {
          title: "支付状态",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.pay_status == 0
                  ? "未支付"
                  : params.row.pay_status == 1
                    ? "支付中"
                    : "已完成"
              )
            ]);
          }
        },
        {
          title: "支付时间",
          key: "pay_at",
          width: 200
        },
        {
          title: "订单状态",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 0 ? "取消" : "正常")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        name: "",
        prices: "",
        descript: ""
      },
      showModalStatus: false,
      exportLoading: false,
    };
  },
  // 组件
  components: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.liveVideosOrder.list({ page: this.pages.page, size: this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 详情
    detail (index, id) {
      this.title = "详情";
      this.showModalStatus = !this.showModalStatus;
      this.$api.liveVideosOrder.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        this.dataInfo.user_name = res.result.userdata != null ? res.result.userdata.username : '';
        this.dataInfo.video_title = res.result.video.title;
        // console.log(res.result.video.title);
        this.dataInfo.pay_status_name =
          res.result.pay_status == 1
            ? "支付中"
            : res.result.pay_status == 0
              ? "未完成"
              : "已完成";
        this.dataInfo.status_name = res.result.status == 1 ? "正常" : "取消";
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        pay_name: this.formItem.pay_name,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.liveVideosOrder.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    exportOrder () {
      this.exportLoading = true;
      this.$api.liveVideosOrder
        .export({
          key: this.formItem.key,
          pay_name: this.formItem.pay_name,
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
  }
};
</script>

<style scoped>
</style>